export const builtinUwConditionCategories = ['PTD', 'PTF', 'PTD - Internal', 'Loan Intake']

export type UwConditionSystemKey = 'ptd' | 'ptf' | 'ptdInternal' | 'loanIntake'

export const isSystemUwConditionCategory = (item: {
  title?: string
  systemKey?: UwConditionSystemKey | string | null
}) => {
  if (item.systemKey) return true
  return !!item.title && builtinUwConditionCategories.includes(item.title)
}

export interface IUWConditionCategory {
  id: number
  title: string
  notes: string
  loanStatus: string[]
  addToLoanStatusRestrictions?: boolean
  systemKey?: UwConditionSystemKey | null
  createdAt: string
  updatedAt: string
}
